
export default {
  data() {
    return {
      forms: [],
      formId: 0,
      formData: null,
      pageData: null,
      selectedFiles: [],
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();
    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },
  methods: {
    setFormId(id) {
      if (this.$refs.formId) {
        this.$refs.formId.registeredEditors[0].instance.componentData.linkMeta.formId =
          id;
      }
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
      if (
        this.pageData &&
        this.pageData.components &&
        this.pageData.components.length
      ) {
        this.pageData.components.forEach((data) => {
          if (data && data.linkMeta && data.linkMeta.formId) {
            this.formId = parseInt(
              data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
            );
            this.getForm();
          }
        });
      }
    },
    async getForm() {
      try {
        const data = await this.$axios.get(
          "/api/v1/cms/form/get/" + this.formId
        );
        if (data) {
          this.formData = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    setFormInputs(form, formData) {
      if (!form || !formData) return;

      formData.fields.forEach((field) => {
        if (formData[field.key]) {
          if (formData[field.key].type !== "file") {
            form[field.key] = formData[field.key];
          }
        } else {
          if (!form[field.key]) {
            form[field.key] = null;
          }
        }
      });
    },
    validateFileSize(file) {
      if (!file) return;

      const fileSize = file.size;
      const fileMb = fileSize / 1024 ** 2;
      if (fileMb > 10) {
        this.$toast.error(this.$t("careers.errorFile"));
        return false;
      } else return true;
    },
    fileUpload(event) {
      if (!event.target.files) return;
      const files = Array.from(event.target.files);
      files.forEach((file) => {
        if (this.validateFileSize(file)) {
          this.selectedFiles.pop();
          this.selectedFiles.push(file.name);

          //for multiple files
          // if (!this.selectedFiles.includes(file.name)) {
          //   this.selectedFiles.push(file.name);
          // }
        }
      });
    },
    deleteFile(file) {
      if (!file) return;
      this.selectedFiles = this.selectedFiles.filter(function (item) {
        return item !== file;
      });
    },
  },
};
